import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    margin: '0',
    display: 'flex',
    padding: '2px 0 2px 10px',
    alignItems: 'center',
    cursor: 'pointer',
    border: `solid 1px ${theme.border.outline}`,
    borderRadius: '4px'
  },

  icon: {
    cursor: 'pointer',
    margin: '0px 7px',
    height: 'auto',
    width: '10px',
    opacity: '0.7'
  },

  info: {
    position: 'static',
    top: 'auto',
    right: 'auto',
    marginLeft: '0.5rem'
  }
}))

export default useStyles
